<template>
  <div class="aftersale-person-bd tb" v-if="funcView.technician_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-button type="primary" @click="editEvent(tableSelect)" :disabled="tableSelect.length === 0">
          <i class="icon icon-renwuguanli"></i>
          {{ funcView.technician_setup }}
        </el-button>
        <el-form-item>
          <p class="tips">{{$t('asm_aftersale_person.zwjqszlshfshfzrglgjq')}}</p>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button class="table-set" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <el-input :placeholder="$t('asm_aftersale_person.htbhjsh')" v-model="formSearch.search" clearable @keyup.enter.native="onCurrentPage(1)" style="width: 280px">
            <template slot="append">
              <div @click="onCurrentPage(1)">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('asm_aftersale_person.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('asm_aftersale_person.xiang_mu')">
          <el-input v-model="formSearch.locationName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_aftersale_person.dai_li_gong_si')">
          <el-input v-model="formSearch.agentCoName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_aftersale_person.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_aftersale_person.zu_lin_fang')">
          <el-input v-model="formSearch.customerName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_aftersale_person.shou_hou_fu_ze_ren')">
          <el-input v-model="formSearch.technicianName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table type="checkbox" :clickSelection="true" v-model="tableSelect" :column="tableColumn" :data="tableList" @filter="filterChange" @sort="sortChange" height="100%" :slots="['action']">
        <template v-slot:action="scope" v-if="funcView.technician_setup">
          <el-button v-if="scope.row.afterServiceId === orgId" type="text" size="mini" @click="editEvent([scope.row])">{{ funcView.technician_setup }}{{ setSelection(scope.row, false) }}</el-button>
          <span v-else>{{ setSelection(scope.row, true) }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <aftersale-area-dialog v-if="dialogVisible" :data="dialogData" :model="dialogModel" @close="dialogVisible = false" @success="getTableList()"></aftersale-area-dialog>
  </div>
</template>
<script>
import apis from '@/utils/apis';
import aftersaleAreaDialog from './children/aftersale_person_dialog.vue';

export default {
  components: { aftersaleAreaDialog },
  name: 'aftersale_person',
  data() {
    return {
      tableCode: 'aftersale_person',
      tableSelect: [],
      provide: true,
      formSearch: {
        productCode: '',
        locationName: '',
        agentCoName: '',
        afterServiceName: '',
        customerName: '',
        technicianName: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },

      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
    };
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getFuncView();
    this.getTableList();
  },
  computed: {
    orgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
  },
  methods: {
    setSelection(row, val) {
      row.isExists = val;
    },
    // 编辑
    editEvent: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('asm_aftersale_person.szsbfzr');
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.TechnicianPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 过滤
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    // 切换页
    onCurrentPage: function (page) {
      this.formSearch.pageNum = page;
      this.getTableList();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getTableList();
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.TechnicianExport, this.formSearch).then(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style/colors.scss';

.aftersale-person-bd {
  .tips {
    color: #4d4d4d;
    font-size: 14px;
    line-height: 32px;
    margin-left: 14px;
  }
}
</style>
